module.exports = __webpack_public_path__ + "static/offices-content-image-3@2x-81b54032db8eab750f1ea568da5642d8.jpg";